import React, { useState } from 'react';
import { MenuIcon, XIcon, ChevronDownIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setOpenDropdown(null);
  };
  const toggleDropdown = (dropdown: string) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };
  return <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-122">
      <div className="container mx-auto px-4 py-4" data-id="element-123">
        <div className="flex justify-between items-center" data-id="element-124">
          <div className="flex items-center" data-id="element-125">
            <Link to="/" className="flex items-center" data-id="element-126">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kpFCHAhXhoTzrUAWGaPcWo/Scherm%C2%ADafbeelding_2025-07-16_om_10.00.16.png" alt="Experience Hikes Logo" className="h-16" data-id="element-127" />
            </Link>
          </div>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-128">
            <div className="relative group" data-id="element-129">
              <button onClick={() => toggleDropdown('greece')} className="flex items-center text-gray-700 hover:text-teal-600 font-medium" data-id="element-130">
                Greece
                <ChevronDownIcon size={16} className={`ml-1 transition-transform ${openDropdown === 'greece' ? 'rotate-180' : ''}`} data-id="element-131" />
              </button>
              {openDropdown === 'greece' && <div className="absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-20" data-id="element-132">
                  <Link to="/greece" className="block px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-teal-600" data-id="element-133">
                    Overview
                  </Link>
                  <Link to="/greece/spring-hiking" className="block px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-teal-600" data-id="element-134">
                    Spring Hiking Trips
                  </Link>
                </div>}
            </div>
            <Link to="/cyprus" className="text-gray-700 hover:text-teal-600 font-medium" data-id="element-135">
              Cyprus
            </Link>
            <Link to="/spain" className="text-gray-700 hover:text-teal-600 font-medium" data-id="element-136">
              Spain
            </Link>
            <Link to="/#blogs" className="text-gray-700 hover:text-teal-600 font-medium" data-id="element-137">
              Blogs
            </Link>
            <Link to="#reviews" className="text-gray-700 hover:text-teal-600 font-medium" data-id="element-138">
              Reviews
            </Link>
            <Link to="/about" className="text-gray-700 hover:text-teal-600 font-medium" data-id="element-139">
              About Us
            </Link>
            <Link to="/contact" className="text-gray-700 hover:text-teal-600 font-medium" data-id="element-140">
              Contact
            </Link>
            <Link to="/join" className="bg-teal-600 text-white px-4 py-2 rounded-md hover:bg-teal-700 transition" data-id="element-141">
              Join a Trip
            </Link>
          </nav>
          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-142">
            <button onClick={toggleMenu} className="text-gray-700" data-id="element-143">
              {isMenuOpen ? <XIcon size={24} data-id="element-144" /> : <MenuIcon size={24} data-id="element-145" />}
            </button>
          </div>
        </div>
        {/* Mobile Navigation */}
        {isMenuOpen && <nav className="md:hidden mt-4 pb-4 space-y-3" data-id="element-146">
            <div data-id="element-147">
              <button onClick={() => toggleDropdown('mobile-greece')} className="flex items-center w-full text-left text-gray-700 hover:text-teal-600 font-medium py-2" data-id="element-148">
                Greece
                <ChevronDownIcon size={16} className={`ml-1 transition-transform ${openDropdown === 'mobile-greece' ? 'rotate-180' : ''}`} data-id="element-149" />
              </button>
              {openDropdown === 'mobile-greece' && <div className="pl-4 mt-1 space-y-2" data-id="element-150">
                  <Link to="/greece" className="block text-gray-700 hover:text-teal-600 py-1" data-id="element-151">
                    Overview
                  </Link>
                  <Link to="/greece/spring-hiking" className="block text-gray-700 hover:text-teal-600 py-1" data-id="element-152">
                    Spring Hiking Trips
                  </Link>
                </div>}
            </div>
            <Link to="/cyprus" className="block text-gray-700 hover:text-teal-600 font-medium py-2" data-id="element-153">
              Cyprus
            </Link>
            <Link to="/spain" className="block text-gray-700 hover:text-teal-600 font-medium py-2" data-id="element-154">
              Spain
            </Link>
            <Link to="/#blogs" className="block text-gray-700 hover:text-teal-600 font-medium py-2" data-id="element-155">
              Blogs
            </Link>
            <Link to="#reviews" className="block text-gray-700 hover:text-teal-600 font-medium py-2" data-id="element-156">
              Reviews
            </Link>
            <Link to="/about" className="block text-gray-700 hover:text-teal-600 font-medium py-2" data-id="element-157">
              About Us
            </Link>
            <Link to="/contact" className="block text-gray-700 hover:text-teal-600 font-medium py-2" data-id="element-158">
              Contact
            </Link>
            <Link to="/join" className="block bg-teal-600 text-white px-4 py-2 rounded-md text-center hover:bg-teal-700 transition" data-id="element-159">
              Join a Trip
            </Link>
          </nav>}
      </div>
    </header>;
};